import { Ref } from 'react';
import { Typography } from '@mui/material';
import { useDeleteStockItemMutation } from '../queries';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { ImperativeDialog } from '@shared/components/dialogs/imperative-dialog';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

type StockItemDeleteDialogProps = {
  stockItemId: string;
  dialogRef: Ref<ImperativeFormDialogRefType | null>;
};

const StockItemDeleteDialog = (props: StockItemDeleteDialogProps) => {
  const { dialogRef, stockItemId } = props;
  const { t } = useIntlTranslations();
  const { mutate: deleteStockItemMutation } = useDeleteStockItemMutation();

  return (
    <ImperativeDialog
      ref={dialogRef}
      onConfirm={() => deleteStockItemMutation(stockItemId)}
      title={t('stockItem.deleteStockItem')}
    >
      <Typography>{t('stock.deleteStockItemWarning')}</Typography>
    </ImperativeDialog>
  );
};

export default StockItemDeleteDialog;
